import React from 'react';

const PoliticalLeaningBadge = ({ leaningScore }) => {
  // Debug logging
  console.log('PoliticalLeaningBadge received leaningScore:', leaningScore);
  
  // Return null if no leaning score is provided
  if (leaningScore === null || leaningScore === undefined) {
    console.log('PoliticalLeaningBadge: leaningScore is null/undefined, returning null');
    return null;
  }

  // Determine political leaning based on score
  const getPoliticalLeaning = (score) => {
    if (score <= -0.5) {
      return {
        label: 'Left leaning',
        color: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
        icon: '←'
      };
    } else if (score >= 0.5) {
      return {
        label: 'Right leaning',
        color: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
        icon: '→'
      };
    } else {
      return {
        label: 'Center leaning',
        color: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
        icon: '•'
      };
    }
  };

  const leaning = getPoliticalLeaning(leaningScore);

  return (
    <span 
      className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${leaning.color} transition-colors`}
      title={`Political leaning score: ${leaningScore}`}
    >
      <span className="mr-1" aria-hidden="true">{leaning.icon}</span>
      {leaning.label}
    </span>
  );
};

export default PoliticalLeaningBadge;
